import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=a24471ac&scoped=true&"
import script from "./CancelButton.vue?vue&type=script&lang=ts&"
export * from "./CancelButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24471ac",
  null
  
)

export default component.exports